module.exports = __webpack_public_path__ + "media/images/icons/destroy-779afa8982ea5f8c9e55ca5e5f96f1ff.svg";